<template>
  <!-- container element for the page -->
  <div class="page-paid-collaborations standard-page">
    <!-- the filters card -->
    <v-card
      class="pa-4 box-shadow-md"
      outlined
    >
      <v-card-text>
        <!-- show all possible options for search/filter -->
        <filter-options :module-id="moduleId" />

        <!-- view the chips for selected/applied filters -->
        <applied-filters
          :filters="appliedFilters"
          @remove="handleRemove"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- submit button -->
        <v-btn
          color="primary"
          depressed
          @click="handleFilters"
          :disabled="isLoading"
        >
          <v-icon left>search</v-icon>
          Search
        </v-btn>
      </v-card-actions>
    </v-card>

    <template v-if="shouldShowResults">
      <!-- Top Hashtags, Mentions, and Sponsored usernames -->
      <top-keywords
        :module-id="moduleId"
        class="my-8 mt-md-12"
      />

      <!-- filtered posts that come up after search is clicked -->
      <!-- use the symbol value as a key to reset the entire local state of this component -->
      <filtered-posts
        :module-id="moduleId"
        :key="shouldShowResults"
      />
    </template>
  </div>
</template>

<script>
const FilterOptions = () => import("@/components/paid-collaborations/FilterOptions.vue")
const AppliedFilters = () => import("@/components/common/AppliedFilters.vue")

const TopKeywords = () => import("@/components/paid-collaborations/TopKeywords.vue")
const FilteredPosts = () => import("@/components/paid-collaborations/FilteredPosts.vue")

export default {
  name: "paidCollaborations",

  components: {
    FilterOptions,
    AppliedFilters,

    TopKeywords,
    FilteredPosts
  },

  data: () => ({
    // to be used to store everything related to this instance
    moduleId: Symbol(Date.now()),

    // to show the progress bars and disable actions
    isLoading: false,

    // for blocking multiple requests to load more data
    _timerId: null,
    requestCompletedAt: null,
  }),

  computed: {
    // get the applied filters from vuex store
    appliedFilters() {
      return this.$store.getters[`paidCollaborations/filters`](this.moduleId)
        .sort((a, b) => a.sort - b.sort)
    },

    shouldShowResults() {
      return this.$store.getters["paidCollaborations/shouldShowResults"](this.moduleId)
    }
  },

  methods: {
    // show a loader for 2 seconds and then show the posts grid
    async handleFilters() {
      // don't let multiple parallel requests to be initiated
      this.isLoading = true

      // fetch these in parallel
      this.$store.dispatch("paidCollaborations/searchTopSponsors", this.moduleId)
      this.$store.dispatch("paidCollaborations/searchTopMentions", this.moduleId)
      this.$store.dispatch("paidCollaborations/searchTopHashtags", this.moduleId)

      // make network requests in vuex store
      await this.$store.dispatch("paidCollaborations/searchPosts", this.moduleId)
      this.requestCompletedAt = Date.now()

      // since the request is complete, enable the submit button
      this.isLoading = false
    },

    handleRemove(data) {
      this.$store.dispatch(`paidCollaborations/removeFilter`, {
        id: this.moduleId,
        filterId: data.id
      })
    }
  },

  mounted() {
    // whenever the component is rendered
    this.$store.dispatch("paidCollaborations/resetResults", this.moduleId)
  }
}
</script>
